import comPagebreak from '@/components/common/pagebreak'
import comEazyswiper from '@/components/common/eazyswiper'

const pagebreak = {
    install: function (Vue) {
        Vue.component('pagebreak', comPagebreak);
        Vue.component('eazyswiper', comEazyswiper);
    }
};

export { pagebreak };


// WEBPACK FOOTER //
// ./src/custom.js